<template>
  <div>
    <b-card>
      <b-row class="mb-3">
        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">№</b>
            <b>#{{ movements.id }}</b>
          </div>
        </b-col>

        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">{{$t('date')}}</b>
            <b>{{ $dayjs(movements.created_at).format("DD.MM.YYYY") }}</b>
          </div>
        </b-col>

        <b-col
          v-if="movements.status"
          class="col-md-2 ml-auto text-right"
        >
          <template v-for="(item, index) in movements.status.change_to" >
             <!-- && hideButtonIfNeeded() -->
            <b-button
              v-if="checkButtonPermission([...item.roles, 'admin']) &&
              hideButtonIfNeeded(item)"
              :key="index"
              size="sm"
              class="ml-50"
              :variant="item.color"
              @click="onChangeStatus(movements, item)"
            >
              {{ item.name }}
            </b-button>
          </template>
        </b-col>
        <!-- <b-col class="col-md-2 ml-auto">
          <b-form-group
            :label="$t('status')"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="[]"
            />
          </b-form-group>
        </b-col> -->
      </b-row>

      <div
        v-if="this.$route.params.type === 'material'"
        class="mb-2"
      >
        <div class="mb-1">
          <div class="d-flex align-items-center justify-content-between mb-1">
            <h4 class="mb-0">
              {{$t('raw_materials')}} / {{$t('sidebar.material')}}
            </h4>
          </div>
          <hr>
          <movement-material-table :movement="movements" />
        </div>
      </div>

      <div
        v-else
        class="mt-3"
      >
        <div class="d-flex align-items-center justify-content-between mb-1">
          <h4 class="mb-0">
            {{$t('sidebar.instrument')}}
          </h4>
        </div>
        <hr>

        <movement-instrument-table :movement="movements" />
      </div>

      <div
        v-if="movements.from_storage"
        class="d-flex align-items-center mt-3"
      >
        <div class="d-flex flex-column">
          <b class="mb-0">{{$t('where2')}}</b>
          <div>
            {{ movements.from_storage.title }}
          </div>
        </div>

        <div
          v-if="movements.to_storage"
          class="d-flex flex-column ml-5"
        >
          <b class="mb-0">{{$t('where')}}</b>
          <div>
            {{ movements.to_storage.title }}
          </div>
        </div>
      </div>

    </b-card>

    <div class="text-right ">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="d-flex align-items-center"
        variant="secondary"
        @click="$router.back()"
      >
        <feather-icon icon="ArrowLeftIcon" size="18" />
        {{ $t("back") }}
      </b-button>
    </div>
    
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BCard,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import MovementInstrumentTable from './tables/MovementInstrumentTable.vue'
import MovementMaterialTable from './tables/MovementMaterialTable.vue'
import check from '@/mixins/check'
import { getUserData } from "@/auth/utils";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    MovementInstrumentTable,
    MovementMaterialTable,

  },
  mixins: [check],
  data() {
    return {



     // ===============  PRIMARY_DATA_SECTION START ===============
      movements: {},
      // ===============  PRIMARY_DATA_SECTION END ===============



    }
  },
  async mounted() {


    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh()
    // ===============  PRIMARY_REQUESTS_SECTION END ===============



  },
  methods: {
    ...mapActions('application', ['FETCH_ONE_APPLICATION_INSTRUMENT_MOVEMENT', 'FETCH_ONE_APPLICATION_MOVEMENT', 'UPDATE_APPLICATION_MATERIAL_MOVEMENT']),
    
    



    // ===============  REFRESH_SECTION START ===============
    async refresh() {
      if (this.$route.params.type === 'instrument') {
        await this.FETCH_ONE_APPLICATION_INSTRUMENT_MOVEMENT(this.$route.params.id)
          .then(res => {
            this.movements = res
          })
      } else {
        await this.FETCH_ONE_APPLICATION_MOVEMENT(this.$route.params.id)
          .then(res => {
            this.movements = res
          })
      }
    },
    // ===============  REFRESH_SECTION END ===============



    hideButtonIfNeeded(){
      let userData = getUserData();
      
      if(this.movements?.from_storage?.id == userData?.storage_object){
        return true
      }else {
        return false
      }
    },



    // ===============  ON_CHANGE_STATUS START ===============
    onChangeStatus(props, item) {
      const status = {
        in_consideration: this.$t('submit_this_application_for_review'),
        confirmed: this.$t('confirm_this_application'),
        denied: this.$t('refuse_this_application'),
        on_way_movement: this.$t('send_on_the_way'),
      }
      this.$bvModal
        .msgBoxConfirm(
          this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
          {
            title: this.$i18n.t('attention'),
            size: 'sm',
            okVariant: item.color,
            okTitle: this.$t('yes'),
            cancelTitle: this.$t('no'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(async value => {
          if (!value) return
          this.UPDATE_APPLICATION_MATERIAL_MOVEMENT({
            status_unique: item.unique_name,
            id: props.id,
          }).then(() => {
            this.refresh()
          })
        })
    },
    // ===============  PRIMARY_DATA_SECTION END ===============





  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
